<form [formGroup]="updateDisplayNameForm" class="flex flex-col gap-1">
    <p class="font-bold">Display Name</p>
    <div class="flex flex-row gap-2">
        <input formControlName="displayName" class="p-1 bg-slate-100 rounded-sm shadow-sm grow disabled:text-slate-400">
        <button (click)="onChangeDisplayNameClicked()" class="w-[8ch] p-1 bg-slate-100 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="!canSubmitDisplayNameChange()">
            @if (!isUpdatingDisplayName) {
                @if (updateSuccess) {
                    <svg-icon [svgIcon]="checkSvgIcon" [small]="true" class="fill-none stroke-green-700"></svg-icon>
                } @else {
                    Change
                }
            } @else {
                <busy-spin [small]="true"></busy-spin>
            }
        </button>
    </div>
    @if (updatingDisplayNameError) {
        <div class="lex flex-col gap-1 border border-red-600 text-xs text-red-600 p-1 rounded">
            {{ updatingDisplayNameError }}
        </div>
    }
    <p class="text-xs text-slate-400">
        Appears on your profile and other locations around the site.
    </p>
</form>